import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { InternalAvatar } from '../../internal';
import * as styles from './styles.module.css';

/**
 * Компонент аватарки
 *
 * Плейсхолдеры и скругления зависят от типа пользователя:
 * Люди - круглые
 * Компании - квадратные
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DoubleAvatar = /*#__PURE__*/React.forwardRef(function DoubleAvatar(_ref, ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    size = _ref.size,
    highlight = _ref.highlight;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles['avatars'],
    style: {
      width: size,
      height: size
    },
    children: [/*#__PURE__*/_jsx(InternalAvatar, _objectSpread(_objectSpread({}, primary), {}, {
      className: styles['primary'],
      ref: ref,
      highlightWidth: 4,
      highlight: highlight,
      size: calcPrimarySize(size)
    })), /*#__PURE__*/_jsx(InternalAvatar, _objectSpread(_objectSpread({}, secondary), {}, {
      className: styles['secondary'],
      highlightWidth: 2,
      highlight: highlight,
      size: calcSecondarySize(size)
    }))]
  });
});
var PRIMARY_SIZE_RATIO = 88 / 94;
var SECONDARY_SIZE_RATIO = 32 / 94;
function calcPrimarySize(size) {
  return Math.round(size * PRIMARY_SIZE_RATIO / 4) * 4;
}
function calcSecondarySize(size) {
  return Math.round(size * SECONDARY_SIZE_RATIO / 4) * 4;
}